export { default as MarketingCarouselItem } from './MarketingCarouselItem';
export type { MarketingCarouselItemProps } from './types';
